<script setup>
import { cn, } from '@/utils/ShadcnUtil';
import { Check, } from 'lucide-vue-next';
import { CheckboxIndicator, CheckboxRoot, useForwardPropsEmits, } from 'reka-ui';
import { computed, } from 'vue';

const props = defineProps({
  defaultValue: { type: [Boolean, String], required: false, default: false },
  modelValue: { type: [
    Boolean, String, null,
  ], required: false, default: null },
  disabled: { type: Boolean, required: false, default: false },
  value: { type: [
    String, Number, Object, null,
  ], required: false, default: null },
  id: { type: String, required: false, default: '' },
  asChild: { type: Boolean, required: false, default: false },
  as: { type: null, required: false, default: 'button' },
  name: { type: String, required: false, default: '' },
  required: { type: Boolean, required: false, default: false },
  class: { type: null, required: false, default: '' },
});
const emits = defineEmits(['update:modelValue']);

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>

<template>
  <CheckboxRoot
    v-bind="forwarded"
    :class="
      cn(
        'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground',
        props.class,
      )
    "
  >
    <CheckboxIndicator
      class="flex h-full w-full items-center justify-center text-current"
    >
      <slot>
        <Check class="h-4 w-4" />
      </slot>
    </CheckboxIndicator>
  </CheckboxRoot>
</template>
